import { EmptyState } from './EmptyState'
import { ProductBanner } from './ProductBanner'
import { ProductCard } from './ProductCard'
import { ProductModal } from './ProductModal'
import { ProductWidget } from './ProductWidget'
import { ProductWidgetPopover } from './ProductWidgetPopover'
import { UpsellButton } from './UpsellButton'
import { UpsellGuard } from './UpsellGuard'

export const UpsellingKit = {
  ProductCard,
  ProductWidget,
  ProductWidgetPopover,
  UpsellGuard,
  UpsellButton,
  ProductModal,
  EmptyState,
  ProductBanner,
}
